import { render, staticRenderFns } from "./RenewalAlarmsModal.vue?vue&type=template&id=0225bbd2&scoped=true"
import script from "./RenewalAlarmsModal.vue?vue&type=script&lang=js"
export * from "./RenewalAlarmsModal.vue?vue&type=script&lang=js"
import style0 from "./RenewalAlarmsModal.vue?vue&type=style&index=0&id=0225bbd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0225bbd2",
  null
  
)

export default component.exports